import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import API from '../utils/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState({ appointments: 0, pending: 0, reviews: 0, gallery: 0 });
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      API.get('/appointments?limit=5'),
      API.get('/reviews/all'),
      API.get('/gallery/all'),
    ]).then(([a, r, g]) => {
      const appts = a.data.data || [];
      const total = a.data.total || 0;
      const pending = appts.filter(x => x.status === 'pending').length;
      setStats({ appointments: total, pending, reviews: (r.data.data || []).length, gallery: (g.data.data || []).length });
      setRecent(appts.slice(0, 5));
    }).catch(() => { }).finally(() => setLoading(false));
  }, []);

  const STATUS_COLOR = { pending: '#B07090', confirmed: '#5D9A57', completed: '#4A7FA5', cancelled: '#C0605A' };

  return (
    <div className="admin-page">
      <h2 className="admin-page__title">Dashboard</h2>
      <p className="admin-page__sub">Welcome back! Here's what's happening at ANN'S.</p>

      {/* Stats cards */}
      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <span className="admin-stat-card__icon">📅</span>
          <div className="admin-stat-card__num">{stats.appointments}</div>
          <div className="admin-stat-card__lbl">Total Bookings</div>
          <Link to="/admin/appointments" className="admin-stat-card__link">View all →</Link>
        </div>
        <div className="admin-stat-card admin-stat-card--accent">
          <span className="admin-stat-card__icon">🔔</span>
          <div className="admin-stat-card__num">{stats.pending}</div>
          <div className="admin-stat-card__lbl">Pending</div>
          <Link to="/admin/appointments?status=pending" className="admin-stat-card__link">Review →</Link>
        </div>
        <div className="admin-stat-card">
          <span className="admin-stat-card__icon">⭐</span>
          <div className="admin-stat-card__num">{stats.reviews}</div>
          <div className="admin-stat-card__lbl">Reviews</div>
          <Link to="/admin/reviews" className="admin-stat-card__link">Manage →</Link>
        </div>
        <div className="admin-stat-card">
          <span className="admin-stat-card__icon">🖼</span>
          <div className="admin-stat-card__num">{stats.gallery}</div>
          <div className="admin-stat-card__lbl">Gallery Images</div>
          <Link to="/admin/gallery" className="admin-stat-card__link">Manage →</Link>
        </div>
      </div>

      {/* Recent bookings */}
      <div className="admin-card" style={{ marginTop: 28 }}>
        <div className="admin-card__header">
          <h3 className="admin-card__title">Recent Appointments</h3>
          <Link to="/admin/appointments" className="admin-link">View all</Link>
        </div>
        {loading ? <div className="admin-loading">Loading…</div>
          : recent.length === 0 ? <div className="admin-empty">No appointments yet.</div>
            : (
              <div className="admin-table-wrap">
                <table className="admin-table">
                  <thead><tr><th>Name</th><th>Service</th><th>Date</th><th>Time</th><th>Status</th></tr></thead>
                  <tbody>
                    {recent.map(a => (
                      <tr key={a._id}>
                        <td><div className="admin-table__name">{a.name}</div><div className="admin-table__sub">{a.phone}</div></td>
                        <td>{a.service}</td>
                        <td>{new Date(a.date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}</td>
                        <td>{a.time}</td>
                        <td><span className="admin-status-pill" style={{ color: STATUS_COLOR[a.status], borderColor: STATUS_COLOR[a.status] }}>{a.status}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
      </div>

      {/* Quick links */}
      <div className="admin-quick-links">
        <h3 className="admin-card__title" style={{ marginBottom: 16 }}>Quick Actions</h3>
        <div className="admin-quick-links__grid">
          {[
            { to: '/admin/services', icon: '✂️', label: 'Add Service' },
            { to: '/admin/gallery', icon: '🖼', label: 'Upload Photo' },
            { to: '/admin/offers', icon: '🎁', label: 'Create Offer' },
            { to: '/admin/settings', icon: '⚙️', label: 'Site Settings' },
          ].map(l => (
            <Link key={l.to} to={l.to} className="admin-quick-link">
              <span className="admin-quick-link__icon">{l.icon}</span>
              <span>{l.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
